import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentsModule } from '@nx-customer-apps/components';

@Component({
    selector: 'vp-no-sales-force-access',
    templateUrl: './no-sales-force-access.component.html',
    styleUrls: ['../errors.scss'],
    imports: [MatButton, ComponentsModule, TranslatePipe]
})
export class NoSalesForceAccessComponent {}
